import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { enumCellConnection } from "sheets/selectors/column-selectors"

import EnumSelectCell from "sheets/components/cells/EnumSelectCell"
import EnumDisplayCell from "sheets/components/cells/EnumDisplayCell"

export const EnumCell = ({
    children,
    displayKey,
    editing,
    field,
    isResourceTable,
    transformFunction,
    ...props
}) => {
    // grab the enum from the field
    const e = DjangIO.enumFromField(field)
    if (editing) {
        return (
            <EnumSelectCell
                choices={e}
                enumFieldName={field.name}
                id={props.sheetId}
                isResourceTable={isResourceTable}
                item={e.by_value(children)}
                {...props}
            />
        )
    } else {
        return (
            <EnumDisplayCell
                choices={e}
                item={e.by_value(children)}
                displayKey={displayKey}
                transformFunction={transformFunction}
                {...props}
            />
        )

    }
}

EnumCell.propTypes = {
    children: PropTypes.node,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    editing: PropTypes.bool,
}

EnumCell.defaultProps = {
    editing: false,
}

export default connect((state, props) => enumCellConnection(state, props), { })(EnumCell)
